$(function () {

  var buildMenu = function (name, id) {
    return '<div class="popover-close-wrapper"><button type="button" class="close" onclick="$(this).parents(\'.popover\').popover(\'hide\');"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button></div>' +
           "<a href='/admin/" + name + "/" + id + "/edit' class='btn btn-secondary btn-block modal-iframe' data-fullscreen='true'>" + i18n.t('edit') + "</a>" + 
           "<a href='/admin/" + name + "/" + id + "/show-details' class='btn btn-secondary btn-block modal-iframe' data-fullscreen='true'>" + i18n.t('show') + "</a>" +
           "<a href='/admin/" + name + "/" + id + "/duplicate' class='btn btn-secondary btn-block modal-iframe' data-fullscreen='true'>" + i18n.t('duplicate') + "</a>" +
           "<a href='/admin/" + name + "/delete/" + id + "' class='btn btn-secondary btn-block modal-iframe'>" + i18n.t('delete') + "</a>";
  };

  $('.popover-trigger').each(function () {
    var $this = $(this);

    $this.popover('destroy').popover({
      trigger: 'click',
      html: true,
      content: buildMenu($this.data('name'), $this.data('id'))
    }).on('show.bs.popover', function () {
      $('[data-react-class="CheckInCheckOut"]').find('.popover-menu').not(this).popover('hide');
    });
  });    

});